interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  hasBottomNav?: boolean;
}

export function PageContainer({ children, className = "", hasBottomNav = false }: PageContainerProps) {
  return (
    <div 
      className={`min-h-screen bg-white ${hasBottomNav ? 'pb-20' : ''} ${className}`}
      style={{ 
        paddingTop: '16px',
        paddingLeft: '16px',
        paddingRight: '16px'
      }}
    >
      {children}
    </div>
  );
}

// 섹션 간 여백을 위한 컴포넌트
export function Section({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={className} style={{ marginBottom: '16px' }}>
      {children}
    </div>
  );
}

// 카드나 컨텐츠 컨테이너
export function ContentCard({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`bg-white rounded-lg ${className}`} style={{ padding: '16px' }}>
      {children}
    </div>
  );
}